module.exports = __webpack_public_path__ + "static/media/11 REGGIANA CALCIO Piazza Vittoria.b5fe022f.svg";